﻿export async function initialiseMobileServicing(vehicle) {
	showSection('MobileServicing', 'Mobile Servicing');

	const { default: MsController } =
		await import('../modules/MobileServicing/controllers/MobileServicingController.js');

	const controller = new MsController({ vehicle });
	await controller.init();
}

export function getMsSavedAnswer() {
	return JSON.parse(localStorage.getItem("msLocalSavedAnswer"));
}

export function removeMsSavedAnswer() {
	localStorage.removeItem("msLocalSavedAnswer");
}